export default "__VITE_ASSET__c8c0133c__"